import { render, staticRenderFns } from "./XhSelect.vue?vue&type=template&id=6721f740&scoped=true&"
import script from "./XhSelect.vue?vue&type=script&lang=js&"
export * from "./XhSelect.vue?vue&type=script&lang=js&"
import style0 from "./XhSelect.vue?vue&type=style&index=0&id=6721f740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721f740",
  null
  
)

component.options.__file = "XhSelect.vue"
export default component.exports